export default "__VITE_ASSET__Dgnz7_Nu__"